import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Base64 } from 'js-base64';
import toastr from 'toastr';
import SweetAlert from 'react-bootstrap-sweetalert';

import {
  FaImage,
} from 'react-icons/fa';
import { getCategories, categoryUpdateWoutFile, clearMenu } from '../api/category';
import Content from '../components/layout/Content';
import Loading from '../components/Loading';
import { IMG_URL } from '../config';

class CategoryList extends Component {
  constructor(props) {
    super(props);
    this.deleteHandler = this.deleteHandler.bind(this);
    this.clearMenus = this.clearMenus.bind(this);
    this.state = {
      masterUser: null,
      sweetAlert: false,
    };
  }

  async componentDidMount() {
    const { user } = this.props;
    // const masterUser = user.isAdmin ? user.id : user.masterUser;
    const masterUser = user && (user.masterUserId || user.id);
    const resCategories = await getCategories(masterUser);
    this.setState({ categories: resCategories.data.categories, masterUser });
  }

  async deleteHandler(category) {
    const { masterUser } = this.state;

    category.displayPicture = null;
    await categoryUpdateWoutFile(masterUser, category).then((result) => result, (error) => {
      console.log('error', error);
      console.log(error.response);
    }).catch((error) => {
      console.log('catch error', error);
    });

    toastr.success('', 'Deleted');
  }

  async clearMenus() {
    const { intl, user, history } = this.props;
    const clearedText = intl.formatMessage({ id: 'clear.menu.success' });
    const error = intl.formatMessage({ id: 'error' });
    this.setState({ sweetAlert: false });
    const masterUser = user && (user.masterUserId || user.id);
    await clearMenu(masterUser).then(() => {
      toastr.success(clearedText);
      this.timeout = setTimeout(() => {
        history.go(0);
      }, 500);
    }, (err) => {
      console.log('error', err);
      toastr.error(error);
    });
  }

  render() {
    const { categories, sweetAlert } = this.state;
    const { intl } = this.props;
    const { user } = this.props;
    // const masterUser = user.isAdmin ? user.id : user.masterUser;
    const masterUser = user && (user.masterUserId || user.id);

    const categoriesListText = intl.formatMessage({ id: 'categories.list' });
    const homeText = intl.formatMessage({ id: 'sidebar.menu.home' });
    const menuEditText = intl.formatMessage({ id: 'sidebar.menu.edit' });
    const confirmText = intl.formatMessage({ id: 'confirm' });
    const areYouSureText = intl.formatMessage({ id: 'areyousure' });
    const cancelText = intl.formatMessage({ id: 'cancel' });
    const clearText = intl.formatMessage({ id: 'clear.menu' });

    return (
      <Content category onClick={() => this.setState({ sweetAlert: true })} title={categoriesListText} breads={[{ to: '/panel', name: homeText }, { name: menuEditText }]} text={clearText}>
        {
          !categories ? <Loading />
            : (
              <Row>
                {
                  categories.map((category) => {
                    let path;
                    if (category.displayPicture) {
                      path = `${IMG_URL}${Base64.encode(masterUser)}/images/q-${category.displayPicture}`;
                    } else {
                      path = null;
                    }
                    return (
                      <Col md="3" key={category.id}>
                        <CategoryWrapper to={`/panel/category/${category.id}`}>
                          <ImageWrapper>
                            {path
                              ? <img width="75px" height="75px" alt="" src={path} />
                              : <FaImage />}
                          </ImageWrapper>
                          <span>{category.displayName}</span>
                        </CategoryWrapper>
                      </Col>
                    );
                  })
                }
              </Row>
            )
        }
        <SweetAlert
          show={sweetAlert}
          warning
          showCancel
          cancelBtnText={cancelText}
          confirmBtnText={confirmText}
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="default"
          title={areYouSureText}
          onConfirm={this.clearMenus}
          onCancel={() => this.setState({ sweetAlert: false })}
        />
      </Content>
    );
  }
}
const CategoryWrapper = styled(Link)`
  display: flex;
  min-height: 50px;
  background: #e8e8e8;
  padding: 10px;
  margin-bottom: 10px;
  color: #666666;
  text-decoration: none !important;
  :hover {
    color: #666666;
  }
`;
const ImageWrapper = styled.div`
  border: 1px dashed #aba5a5;
  width: 75px;
  height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  border-radius: 3px;
`;

CategoryList.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  user: PropTypes.shape({
    isAdmin: PropTypes.number,
    id: PropTypes.number,
    masterUserId: PropTypes.oneOf([PropTypes.number, null]),
  }).isRequired,
  history: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
    push: PropTypes.func.isRequired,
    go: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => ({ user: state.auth.user });
export default injectIntl(connect(mapStateToProps)(CategoryList));
